const c = {
  name: "World",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21.3,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C20.7,3.8,21.3,4.3,21.3,5z"/>
		<path class="st0" d="M9.3,11c0,0.7-0.6,1.2-1.2,1.2S6.8,11.7,6.8,11c0-0.7,0.6-1.2,1.2-1.2S9.3,10.3,9.3,11z"/>
		<path class="st0" d="M13.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C12.7,9.8,13.3,10.3,13.3,11z"
			/>
		<path class="st0" d="M16,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,11.7,15.3,12.3,16,12.3z"
			/>
		<path class="st0" d="M21.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,9.8,21.3,10.3,21.3,11z"
			/>
		<path class="st0" d="M24,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,11.7,23.3,12.3,24,12.3z"
			/>
		<path class="st0" d="M29.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,9.8,29.3,10.3,29.3,11z"
			/>
		<path class="st0" d="M32,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.8,11.7,31.3,12.3,32,12.3z"
			/>
		<path class="st0" d="M11.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C10.7,12.8,11.3,13.3,11.3,14z"
			/>
		<path class="st0" d="M18,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,14.7,17.3,15.3,18,15.3z"
			/>
		<path class="st0" d="M23.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,12.8,23.3,13.3,23.3,14z"
			/>
		<path class="st0" d="M26,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,14.7,25.3,15.3,26,15.3z"
			/>
		<path class="st0" d="M31.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,12.8,31.3,13.3,31.3,14z"
			/>
		<path class="st0" d="M34,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C32.8,14.7,33.3,15.3,34,15.3z"
			/>
		<path class="st0" d="M18,9.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,8.7,17.3,9.3,18,9.3z"/>
		<path class="st0" d="M23.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,6.8,23.3,7.3,23.3,8z"/>
		<path class="st0" d="M26,9.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,8.7,25.3,9.3,26,9.3z"/>
		<path class="st0" d="M31.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,6.8,31.3,7.3,31.3,8z"/>
		<path class="st0" d="M16,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,17.7,15.3,18.3,16,18.3z"
			/>
		<path class="st0" d="M21.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,15.8,21.3,16.3,21.3,17z"
			/>
		<path class="st0" d="M24,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,17.7,23.3,18.3,24,18.3z"
			/>
		<path class="st0" d="M29.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,15.8,29.3,16.3,29.3,17z"
			/>
		<path class="st0" d="M32,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.8,17.7,31.3,18.3,32,18.3z"
			/>
		<path class="st0" d="M37.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C36.7,15.8,37.3,16.3,37.3,17z"
			/>
		<path class="st0" d="M18,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,20.7,17.3,21.3,18,21.3z"
			/>
		<path class="st0" d="M23.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,18.8,23.3,19.3,23.3,20z"
			/>
		<path class="st0" d="M26,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,20.7,25.3,21.3,26,21.3z"
			/>
		<path class="st0" d="M31.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,18.8,31.3,19.3,31.3,20z"
			/>
		<path class="st0" d="M34,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C32.8,20.7,33.3,21.3,34,21.3z"
			/>
		<path class="st0" d="M25.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,21.8,25.3,22.3,25.3,23z"
			/>
		<path class="st0" d="M28,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.8,23.7,27.3,24.3,28,24.3z"
			/>
		<path class="st0" d="M33.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C32.7,21.8,33.3,22.3,33.3,23z"
			/>
		<path class="st0" d="M36,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C34.8,23.7,35.3,24.3,36,24.3z"
			/>
		<path class="st0" d="M15.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,24.8,15.3,25.3,15.3,26z"
			/>
		<path class="st0" d="M18,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,26.7,17.3,27.3,18,27.3z"
			/>
		<path class="st0" d="M23.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,24.8,23.3,25.3,23.3,26z"
			/>
		<path class="st0" d="M26,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,26.7,25.3,27.3,26,27.3z"
			/>
		<path class="st0" d="M31.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,24.8,31.3,25.3,31.3,26z"
			/>
		<path class="st0" d="M34,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C32.8,26.7,33.3,27.3,34,27.3z"
			/>
		<path class="st0" d="M13.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C12.7,27.8,13.3,28.3,13.3,29z"
			/>
		<path class="st0" d="M16,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,29.7,15.3,30.3,16,30.3z"
			/>
		<path class="st0" d="M21.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,27.8,21.3,28.3,21.3,29z"
			/>
		<path class="st0" d="M24,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,29.7,23.3,30.3,24,30.3z"
			/>
		<path class="st0" d="M29.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,27.8,29.3,28.3,29.3,29z"
			/>
		<path class="st0" d="M32,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.8,29.7,31.3,30.3,32,30.3z"
			/>
		<path class="st0" d="M15.3,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C14.7,30.8,15.3,31.3,15.3,32z"
			/>
		<path class="st0" d="M18,33.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.3-1.2-1.3c-0.7,0-1.2,0.6-1.2,1.3C16.8,32.7,17.3,33.3,18,33.3z"
			/>
		<path class="st0" d="M23.3,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C22.7,30.8,23.3,31.3,23.3,32z"
			/>
		<path class="st0" d="M26,33.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.3-1.2-1.3c-0.7,0-1.2,0.6-1.2,1.3C24.8,32.7,25.3,33.3,26,33.3z"
			/>
		<path class="st0" d="M31.3,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C30.7,30.8,31.3,31.3,31.3,32z"
			/>
		<path class="st0" d="M16,36.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,35.7,15.3,36.3,16,36.3z"
			/>
		<path class="st0" d="M21.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,33.8,21.3,34.3,21.3,35z"
			/>
		<path class="st0" d="M24,36.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,35.7,23.3,36.3,24,36.3z"
			/>
		<path class="st0" d="M39.4,14.9c0.4,1.4,0.6,2.9,0.6,4.3l0,0c0,0.3,0,0.6,0,0.8c0,0.3,0,0.5,0,0.8c0,1.4-0.3,2.9-0.6,4.3
			c-0.2,0.9-0.5,1.7-0.8,2.5c-0.2,0.4-0.3,0.8-0.5,1.1l0,0.1c-0.3,0.7-0.7,1.3-1.1,2c-0.3,0.5-0.6,0.9-0.9,1.3
			c-0.5,0.6-1,1.2-1.5,1.8c-3,3.2-6.9,5.2-11.2,5.9h-0.1c-0.5,0.1-1.1,0.2-1.8,0.2c-0.4,0-0.8,0-1.3,0s-0.9,0-1.3,0
			c-0.7,0-1.3-0.1-1.8-0.2h-0.1C7.1,38.2,0,29.9,0,20c0-3,0.7-6,2-8.7l0-0.1c0.3-0.7,0.7-1.3,1.1-2c0.3-0.5,0.6-0.9,0.9-1.3
			c0.5-0.6,1-1.2,1.5-1.8C9.4,2.2,14.5,0,20,0c4.1,0,8.1,1.2,11.5,3.6c0.7,0.5,1.3,1,2,1.6c0.3,0.3,0.6,0.6,0.9,0.9
			C35,6.7,35.5,7.3,36,7.9c0.3,0.4,0.6,0.8,0.9,1.3c0.4,0.7,0.8,1.3,1.1,2l0.1,0.1c0.2,0.4,0.3,0.7,0.5,1.1
			C38.8,13.2,39.1,14.1,39.4,14.9z M18,36.8c0.7,0,1.2,0.5,1.2,1.2h0c0.5,0,1,0,1.5,0c0-0.7,0.6-1.2,1.2-1.2c0.6,0,1,0.4,1.2,1
			c1.6-0.3,3.2-0.8,4.6-1.5c-0.6-0.1-1.1-0.6-1.1-1.2c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2c0,0.2,0,0.4-0.1,0.5
			c1.4-0.8,2.6-1.8,3.8-3c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.7,0.6-1.3,1.2-1.3c0.1,0,0.3,0,0.4,0.1c0.2-0.3,0.5-0.7,0.7-1
			c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.7,0.6-1.2,1.2-1.2c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0.2-0.3,0.3-0.6,0.4-1c0-0.1,0-0.1,0.1-0.2
			c0-0.1,0-0.1,0.1-0.2c0-0.1-0.1-0.2-0.1-0.4c0-0.4,0.2-0.8,0.5-1c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2
			c0.3-1.1,0.5-2.2,0.5-3.3c-0.7,0-1.2-0.6-1.2-1.2s0.5-1.2,1.2-1.2c-0.1-1.1-0.2-2.2-0.5-3.3c0-0.1,0-0.1-0.1-0.2
			c0-0.1,0-0.1-0.1-0.2c-0.3-0.2-0.5-0.6-0.5-1c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.2-0.1-0.3
			c-0.1-0.4-0.3-0.7-0.5-1c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c-0.7,0-1.2-0.6-1.2-1.2c0-0.3,0.1-0.6,0.3-0.8c-0.2-0.3-0.4-0.7-0.7-1
			c-0.1,0-0.2,0.1-0.4,0.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0.1-0.4,0.1-0.5c-0.3-0.3-0.5-0.5-0.8-0.8c-0.3-0.2-0.5-0.4-0.8-0.7
			c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.2-0.5-0.4-0.8-0.6C30,5,29.5,4.7,29.1,4.5c0.1,0.2,0.1,0.3,0.1,0.5c0,0.7-0.6,1.2-1.2,1.2
			S26.8,5.7,26.8,5c0-0.6,0.5-1.1,1.1-1.2C25.4,2.6,22.8,2,20,2c-4.9,0-9.5,1.9-12.9,5.5C7.2,7.6,7.3,7.8,7.3,8
			c0,0.7-0.6,1.2-1.2,1.2c-0.1,0-0.3,0-0.4-0.1c-0.2,0.3-0.5,0.7-0.7,1c0.2,0.2,0.3,0.5,0.3,0.8c0,0.7-0.6,1.2-1.2,1.2
			c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0C2.6,14.6,2,17.3,2,20c0,8.8,6.2,16.2,14.8,17.7C17,37.2,17.4,36.8,18,36.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as World
};
